import { render } from "./DonorScholarshipDetails.vue?vue&type=template&id=5f5c40ab"
import script from "./DonorScholarshipDetails.vue?vue&type=script&lang=js"
export * from "./DonorScholarshipDetails.vue?vue&type=script&lang=js"
script.render = render

export default script